$(document).ready(function() {
    if ($('.paginate').find('.page:not(.disable)').length > 0)
        $('.paginate').css('display', 'flex');
    else
        $('.paginate').css('display', 'none');

    $(document).on('click', '.paginate a', function(e) {
        e.preventDefault();

        let newUrl = $(this).attr('href');

        $.ajax({
            type: "GET",
            url: newUrl,
            success: function(data) {
    
                $('.article-list').html($(data).find('.article-list').html());
    
                //show hide pagination
                if ($('.paginate').find('.page:not(.disable)').length > 0)
                    $('.paginate').css('display', 'flex');
                else
                    $('.paginate').css('display', 'none');

                
                $('html, body').animate({
                    scrollTop: $('#knowledge-section-2').offset().top
                }, 0);
            },
            error: function() {
                console.log("Error occurred while paginating.");
            },
        });
        
        if (window.history && window.history.pushState) {
            window.history.pushState(null, null, newUrl);
        }
    });
})